import React, {useCallback, useRef} from "react";
import {InputLayout} from "./InputLayout";
import {helpTextSuffix, notificationSuffix} from "./inputConstants";

interface TextAreaProps {
    disabled?: boolean;
    helpText?: string;
    label: string;
    name: string;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    placeholder?: string;
    value?: string | number;
    error?: string;
    responseFeedback?: string;
    rows?: number;
    medium_columns?: string;
    setValue?: (value: string) => void;
    setError?: (error: string) => void;
}

export const TextArea = React.memo<TextAreaProps>(({
    disabled,
    helpText,
    label,
    name,
    onChange,
    placeholder,
    value = "",
    error,
    responseFeedback,
}) => {
    const changeHandlerEnabled = useRef(true);

    const handleOnChange = useCallback((event: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (changeHandlerEnabled.current) {
            onChange?.(event);
        }
    }, [onChange]);

    const handleOnInput = useCallback((event: React.FormEvent<HTMLTextAreaElement>) => {
        changeHandlerEnabled.current = false;
        onChange?.(event as unknown as React.ChangeEvent<HTMLTextAreaElement>);
    }, [onChange]);

    return (
        <InputLayout
            disabled={disabled}
            helpText={helpText}
            label={label}
            name={name}
            error={error}
            responseFeedback={responseFeedback}
        >
                <textarea
                    aria-disabled={disabled}
                    aria-invalid={!!error}
                    aria-errormessage={error ? `${name}${notificationSuffix}` : undefined}
                    aria-describedby={helpText ? `${name}${helpTextSuffix}` : undefined}
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={handleOnChange}
                    onInput={handleOnInput}
                    readOnly={disabled}
                />
        </InputLayout>
    );
});
